import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import DS from 'ember-data';

export default class ObjectsEditController extends Controller {
  @service store!: DS.Store;

  get objectTypes() {
    return this.store
      .peekAll('object-type')
      .toArray()
      .filter((objectType) => !objectType.get('isNew'));
  }
}
